// extracted by mini-css-extract-plugin
module.exports = {"currentEmail":"changeEmailPopup-module__currentEmail___NYiN8"};